import { render, staticRenderFns } from "./PetitionCommentsList.vue?vue&type=template&id=21a73ce6"
import script from "./PetitionCommentsList.vue?vue&type=script&lang=js"
export * from "./PetitionCommentsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports